import React from 'react';
import Avatar from './Avatar';
import { User, Support, Student } from '../messages.types';
import clsx from 'clsx';
import { If } from 'vite-plugin-react-control-statements';

interface ChatItemProps {
	item: User | Support | Student;
	isActive?: boolean;
	onClick: () => void;
	isSupport?: boolean;
}

const ChatItem: React.FC<ChatItemProps> = ({ item, isActive = false, isSupport = false, onClick }) => {
	return (
		<div
			className={`chat-list-item ${isActive ? 'active' : ''}`}
			onClick={onClick}>
			<Avatar
				src={item.avatar}
				alt={`${item.name} ${item.surname}`}
			/>

			<div className="info">
				<div className="name-wrapper">
					<div className="name">{`${item.name} ${item.surname}`}</div>
					<If condition={!!item?.isTopRanked}>
						<div className="student-top-ranked">
							<i className="icons-medal" />
							Derece Öğrencisi
						</div>
					</If>
				</div>
				<div className={clsx('description', { 'support-description': isSupport })}>{'grade' in item ? item.grade : 'title' in item ? item.title : ''}</div>
			</div>
			{(item.unreadCount || 0) > 0 && <span className="badge">{item.unreadCount}</span>}
		</div>
	);
};

export default ChatItem;
